import type { ReactElement } from 'react';

import { DrawerRoot } from '@pp/core/src/components/game/drawer/root/DrawerRoot';

import { BetsInfoController } from '../../controllers/BetsInfoController';
import { Drawer } from '../Drawer/Drawer';

import styles from './LauncherLayout.module.css';

interface DrawerWrapperProps {
  table: any;
  isLandscape: boolean;
  onClose: () => void;
}

export const DrawerWrapper = ({ table, isLandscape, onClose }: DrawerWrapperProps): ReactElement => {
  const mini = table.isMtbMinimized;
  const betsInfo = BetsInfoController.getAllBetsInfo();
  const tableBetInfo = betsInfo[table.tableId];
  const totalBet = tableBetInfo?.betAmount ?? 0;
  const shouldStayAtTable = table.jurisdiction === 'it' && totalBet > 0;

  return (
    <div
      key="mtb-drawer"
      className={styles.item}
      style={isLandscape ? { position: 'absolute', width: '100%', height: '100%', pointerEvents: 'none' } : undefined}
    >
      <Drawer
        open
        expandable
        mini={mini}
        className={styles.dragHeight}
        minimize
        onClose={onClose}
        shouldStayAtTable={shouldStayAtTable}
      >
        <iframe
          name={`launcher-${table.tableId}`}
          src={table.url}
          width="100%"
          height="100%"
          className={styles.iframeBorder}
          allowFullScreen
        />
      </Drawer>
      <DrawerRoot />
    </div>
  );
};
